import { Injectable } from '@angular/core';
import { LogAPIService } from '../API/LogAPI.service';
@Injectable({
    providedIn: 'root'
  })


export class LogService{

  constructor(
    private logService: LogAPIService){}
  
    getById( id : number){
    return this.logService.getById(id);
  }
}
